import { commonRoutes } from '../commonRoutes';

export const WOW_CLASSIC_ROUTES = {
  ...commonRoutes,

  LiveLoggedEncounterList: '/live/raid-encounters/:raid/:filter/:page?',

  CharacterRankings: '/character-rankings/:type/:region/:realm/:faction/:class/:page?'
};

export type TClassicRoutes = typeof WOW_CLASSIC_ROUTES;
